import * as React from "react";

export default function FormText(props: React.HTMLProps<HTMLDivElement>) {
	const { className, ...nextProps } = props;
	return <div className={"form-text " + (props.className ?? "")} {...nextProps}>
		{props.children}
	</div>;
}